module.exports = __webpack_public_path__ + "media/images/badge-pretty-11f5d2c187ac23ca2cb6549e28e24639.gif";